export const GET_MOVER = "GET_MOVER";
export const SEARCH_FILTER = "SEARCH_FILTER";
export const GET_MOVER_JOB_DETAIL = "GET_MOVER_JOB_DETAIL";
export const GET_UPDATED_JOB_LIST = "GET_UPDATED_JOB_LIST"

